@if (_result(); as result) {
  <section
    class="result-block m-flex m-flex-column m-gap:2 m-padding:2 m-border m-border-color:grey-200 m-border-radius:lg m-bg-color:grey-100"
  >
    <header class="m-flex m-gap:2 m-flex-items:center m-flex-justify:between">
      <div class="m-flex m-flex-column">
        <span class="m-text-body m-text-weight:bold">{{ result.title }}</span>
        <span class="m-text-body:small m-text-color:neutral">
          {{ result.previewRows.length }} / {{ result.rowCount }}
          {{ chatWordings.citationRows() }}
        </span>
      </div>

      <div class="m-flex m-gap:1 m-flex-items:center">
        <button
          class="result-block__action"
          type="button"
          [attr.aria-label]="chatWordings.copy()"
          (click)="copyRows()"
        >
          <i [class]="_copied() ? 'myre-icon-check' : 'myre-icon-copy'"></i>
          <span>{{
            _copied() ? chatWordings.copied() : chatWordings.copy()
          }}</span>
        </button>

        @if (result.export; as exportAffordance) {
          <button
            class="result-block__action result-block__action--primary"
            type="button"
            [disabled]="_exporting()"
            (click)="requestExport()"
          >
            <i class="myre-icon-download"></i>
            <span>{{ exportAffordance.label }}</span>
          </button>
        }
      </div>
    </header>

    @if (_sheet(); as sheet) {
      <!--
        The whole table is one click away, and the preview is the affordance:
        it is the thing the reader is already looking at when they want more of
        it. The button beside it keeps the gesture reachable from the keyboard.
      -->
      <button
        class="result-block__table m-overflow-x:auto"
        type="button"
        [attr.aria-label]="chatWordings.citationShowAll()"
        (click)="openTable()"
      >
        <myre-sheet [content]="sheet" />
      </button>
    }

    <div class="m-flex m-gap:2 m-flex-items:center m-flex-justify:between">
      <p class="result-block__perimeter m-text-body:small m-text-color:neutral">
        {{ result.perimeterLine }}
      </p>

      @if (_exportFailed()) {
        <span class="m-text-body:small m-text-color:error">
          {{ chatWordings.actionFailed() }}
        </span>
      }
    </div>
  </section>
}
